// @ts-nocheck
import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import {
    getBreakpointMediaQuery,
    getValueMediaQuery,
    MediaOption,
} from "@store/Framework/Common/Utilities/mediaQueries";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { StyledTheme } from "@toolkit/Framework/Types/StyledTheme";
import findIndex from "lodash/findIndex";
import { ThemedStyledProps } from "styled-components";

export type BreakpointArguments = [BreakpointKey, MediaOption];

const getExtendedBreakpoints = (breakpoints: Toolkit.Theme.Breakpoints) => {
    const { keys, values, extend } = breakpoints;

    if (!extend) {
        return { keys, values };
    }

    const _keys = [...keys] as string[];
    const _values = [...values];

    for (const [key, value] of Object.entries(extend)) {
        let index = findIndex(_values, x => x > value);
        index = index >= 0 ? index : _values.length;

        _keys.splice(index, 0, key);
        _values.splice(index, 0, value);
    }

    return { keys: _keys, values: _values };
};

export default (key: LiteralUnion<BreakpointKey> | number, option: MediaOption = "up") => {
    return (props: ThemedStyledProps<{}, StyledTheme>) => {
        let mediaQuery = null;

        if (typeof key === "number") {
            mediaQuery = getValueMediaQuery(key, option);
        } else if (props.theme) {
            mediaQuery = getBreakpointMediaQuery(key, option, getExtendedBreakpoints(props.theme.breakpoints), {
                first: false,
            });
        }

        return mediaQuery ?? "&";
    };
};
